import classNames from "classnames";
import { Flex } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";

import { CustomValuePillProps } from "../custom_value_pill";
import css from "./grouped_icon.module.scss";

type VerifiedGroupedIconProps = {
  isVerified?: boolean;
  isVerifiedCredly?: boolean;
  isVerifiedOthers?: boolean;
} & Pick<CustomValuePillProps, "theme">;

export const VerifiedGroupedIcon = ({
  isVerified,
  isVerifiedCredly,
  isVerifiedOthers,
  theme
}: VerifiedGroupedIconProps) => {
  const iconsCount = [isVerified, isVerifiedOthers].filter(Boolean).length;

  if (iconsCount > 1) {
    return (
      <Flex center className={classNames(css.groupedIconBackground, { [css.dark]: theme === "dark" })}>
        <Icon name="check" color="paletteWhite0" size="xxs" />
      </Flex>
    );
  }
  if (isVerified) {
    return <Icon name={isVerifiedCredly ? "verified-credly" : "verified"} size="sm" />;
  }
  if (isVerifiedOthers) {
    return <Icon name="verified-others" size="sm" />;
  }

  return null;
};
